import { useQueryClient } from "@tanstack/react-query";
import { useSocketEvent } from "../../lib/socket";
import { updatePostEverywhere } from "../../lib/queryClient";

/** Live like/comment/repost counts pushed by the server ("post:counts"). */
export function usePostCountsLive() {
  useSocketEvent("post:counts", (p) => {
    updatePostEverywhere(p.id, (post) =>
      post.likeCount === p.likeCount && post.commentCount === p.commentCount && post.repostCount === p.repostCount
        ? post
        : { ...post, likeCount: p.likeCount, commentCount: p.commentCount, repostCount: p.repostCount },
    );
  });
}

/** Relationship changes (follows, friends, blocks) from either side: refetch what depends on them. */
export function useRelationshipsLive() {
  const qc = useQueryClient();
  useSocketEvent(
    "relationships",
    () => {
      for (const key of ["friends", "friend-counts", "relations", "profile", "suggestions", "follow-list"]) void qc.invalidateQueries({ queryKey: [key] });
    },
    [qc],
  );
}
